import { VFC } from 'react'
import { useEventItemData } from 'src/api/event'
import { withLoginUser } from 'src/api/user'
import { EventDetailLayout } from './EventDetailLayout'

export const EventDetail: VFC<{ id: number }> = withLoginUser(
  ({ user, id }) => {
    const { data, isValidating } = useEventItemData(id)
    if (isValidating || !data) {
      // TODO Loading
      return <></>
    }
    return <EventDetailLayout user={user} event={data} />
  },
)
